module.exports = __webpack_public_path__ + "img/bg-wallet-success-modal-dark.0acbd6e7.png";